/* eslint-disable  */

import useEmployee from "hooks/useEmployee";
import { devices } from "library/constants";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import PackageUserSelect from "components/PackageUserSelect/PackageUserSelect";
import { Flex, StyledTooltip } from "components/styled";
import { useAtomValue } from "jotai";
import { EBenefitContentTab } from "library/types";
import { selectedClientAtom } from "store";
import { benefitContentTabAtom } from "store/UIBenefitsPage";
import { ShowExpiredPackagesSwitch } from "../BenefitsPageContent/ShowExpiredPackagesSwitch";
import { ContentSelection } from "./ContentSelection";

export function BenefitsPageHeader() {
  const selectedBenefitContentTab = useAtomValue(benefitContentTabAtom);

  const { t } = useTranslation();
  const { employeeData } = useEmployee();
  const selectedClient = useAtomValue(selectedClientAtom);

  const isExpiredBenefitsTab = selectedBenefitContentTab === EBenefitContentTab.expired;
  const isAllBenefitsTab = selectedBenefitContentTab === EBenefitContentTab.all;

  const showExpiredSwitchVisible = !isExpiredBenefitsTab && !isAllBenefitsTab;

  return (
    <Container>
      <Title>
        {t("hbh.greeting.label", {
          name: employeeData?.firstName || "",
        })}
      </Title>
      <StyledTooltip
        relationship="label"
        content={{
          children: selectedClient?.messageToEmployees ?? t("hbh.welcome.label"),
        }}
      >
        <Subtitle>{selectedClient?.messageToEmployees ?? t("hbh.welcome.label")}</Subtitle>
      </StyledTooltip>
      <ContentSelection />
      <ActionWrap>
        <UserSelectWrap>
          <PackageUserSelect />
        </UserSelectWrap>
        {showExpiredSwitchVisible && <ShowExpiredPackagesSwitch />}
      </ActionWrap>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 5px;
  padding-bottom: 0px;

  position: sticky;
  top: 0;
  background: ${(props) => props.theme.palette.themeBackground};
  z-index: 9999;

  @media only screen and ${devices.md} {
    padding-bottom: 20px;
    gap: 10px;
  }
`;

const Title = styled.h1`
  font-weight: 600;
  font-size: 18px;
  margin: 0;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media only screen and ${devices.md} {
    font-size: 24px;
    line-height: 30px;

    max-width: 700px;
  }
`;

const Subtitle = styled.h2`
  max-width: 1200px;
  font-weight: 400;
  font-size: 14px;
  margin: 0;
  @media only screen and ${devices.md} {
    font-size: 18px;
  }
`;
const UserSelectWrap = styled.div`
  width: 100%;
  @media only screen and ${devices.md} {
    width: 550px;
  }
`;

const ActionWrap = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
  justify-content: space-between;
  margin-top: 5px;

  @media only screen and ${devices.md} {
    gap: 15px;
    margin-top: 10px;
  }
`;
